module.exports = __webpack_public_path__ + "img/edit_pencil.f09d6aac.svg";